import React from 'react';
import { DivScrollBody } from './styles';

export function Contrato() {

	return (
		<DivScrollBody style={{ overflowX: 'auto', fontSize: '14px', height: '500px' }}>
			<h6 style={{ paddingTop: '1pt', textIndent: '0pt', paddingBottom: '40px', textAlign: 'center' }}>
				CONTRATO DE CREDENCIAMENTO E ADESÃO DE ESTABELECIMENTOS AO SISTEMA LUCREE
			</h6>
			<p style={{ textAlign: 'justify' }}>
			Por este instrumento, a pessoa jurídica ou a pessoa física qualificada na respectiva Proposta de Credenciamento e Adesão de Estabelecimentos ao SISTEMA LUCREE (“PROPOSTA DE CREDENCIAMENTO”) ou documento equivalente aceito pela LUCREE, os quais são parte integrante deste CONTRATO, ora designada ESTABELECIMENTO e a LUCREE SOLUÇÕES INTELIGENTES S.A., sociedade limitada, com sede na Avenida Luiz Carlos Berrini, nº 105, salas 1105 e 1106, Subcondomínio Thera Office, torre 2, setor B, Cidade Monções, CEP 04571-010, na Cidade de São Paulo, Estado de São Paulo, inscrita no CNPJ/MF sob o nº 26.794.946/0001-60 (“LUCREE”), denominadas individualmente como Parte ou coletivamente como Partes, têm entre si justo e acordado este CONTRATO, uma vez aprovada a sua adesão ao SISTEMA LUCREE, nos termos e condições abaixo:
			</p>

			<h7><b>OBJETO</b></h7>

			<p style={{ paddingTop: '10px' }}><h7>1. O objeto deste CONTRATO é:</h7></p>

			<p style={{ textAlign: 'justify' }}>
				(a) a promoção de pagamentos e recebimentos por meio eletrônico, caracterizados pela captura, roteamento, transmissão e processamento de TRANSAÇÕES, que ocorrerão como consequência do credenciamento do ESTABELECIMENTO para integrar o SISTEMA LUCREE. Uma vez credenciado ao SISTEMA LUCREE, o ESTABELECIMENTO estará habilitado a aceitar os respectivos CARTÕES e MEIOS DE PAGAMENTO e a usufruir dos respectivos PRODUTOS; e
			</p>
			<p style={{ textAlign: 'justify' }}>
				(b) a administração, garantia e/ou efetivação da liquidação financeira ao ESTABELECIMENTO do VALOR LÍQUIDO das TRANSAÇÕES, desde que cumpridos os termos e condições deste CONTRATO.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>1.1. Constituem atividades relacionadas ao objeto deste CONTRATO:</p>
				<p>(a) o fornecimento de COMPROVANTES DE VENDAS, RESUMOS DE VENDAS e EQUIPAMENTOS, possibilitando a captura eletrônica das TRANSAÇÕES;</p>
				<p>(b) a promoção e a divulgação do ESTABELECIMENTO aos PORTADORES, mediante fornecimento de sinalização específica e MATERIAIS;</p>
				<p>(c) a coordenação e a manutenção adequada da operacionalidade do SISTEMA LUCREE; e</p>
				<p>(d) a disponibilização ao ESTABELECIMENTO de múltiplas BANDEIRAS, cuja listagem se encontra no PORTAL DE SERVIÇOS LUCREE para consulta e conhecimento.</p>
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				1.2. Os serviços e atividades de que trata essa Cláusula são prestados e/ou propiciados aos
				ESTABELECIMENTOS pelos integrantes do SISTEMA LUCREE (dentre eles, a LUCREE,
				ADQUIRENTES, EMISSORES e BANDEIRAS), por intermédio da LUCREE, cabendo a cada um deles,
				conforme o serviço efetivamente prestado ao ESTABELECIMENTO e conforme acordado em
				contratos próprios, uma parcela da TAXA DE DESCONTO, da TARIFA POR TRANSAÇÃO ou,
				conforme o caso, de outras formas de remuneração previstas neste CONTRATO.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				1.3. As definições que permitem um melhor entendimento deste CONTRATO, de seus Aditivos e
				de documentos vinculados se encontram no ANEXO I.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				1.4. Este CONTRATO não gera nenhum direito de exclusividade às Partes, podendo o
				ESTABELECIMENTO firmar contratos semelhantes com outras empresas que possuam a mesma
				atividade da LUCREE.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				1.5. São partes integrantes deste CONTRATO e de seu objeto, o ANEXO I, a PROPOSTA DE
				CREDENCIAMENTO, ou documento equivalente aceito pela LUCREE, ou quaisquer documentos
				vinculados e/ou Aditivos, bem como os instrumentos específicos dos PRODUTOS disponíveis no
				SISTEMA LUCREE, os quais podem ser acessados por meio do PORTAL DE SERVIÇOS LUCREE. Em
				caso de conflito entre referidos documentos e este CONTRATO, prevalecerá o CONTRATO, a
				menos que um instrumento específico altere expressamente esta condição.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				1.6. Em virtude da natureza dos serviços ora contratados, o ESTABELECIMENTO concorda com o
				fato de que a LUCREE atuará na condição de SUBADQUIRENTE, promovendo pagamentos e
				recebimentos por meio eletrônico entre os titulares dos cartões de crédito/débito
				(PORTADORES), as ADQUIRENTES com as quais a LUCREE possua vínculo direto e o
				ESTABELECIMENTO.
			</p>


			<p><b>CREDENCIAMENTO</b></p>

			<p style={{ textAlign: 'justify' }}>
				2. O início do processo de credenciamento e adesão do ESTABELECIMENTO ao SISTEMA LUCREE
				poderá ocorrer pelos seguintes canais: bancos, correspondentes bancários, telemarketing, empresas
				terceiras ou parceiras, área comercial da LUCREE, por auto credenciamento via PORTAL DE SERVIÇOS
				LUCREE, ou ainda por outros canais que vierem a ser disponibilizados pela LUCREE.
			</p>
			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				2.1. O credenciamento por quaisquer dos canais disponíveis consiste na solicitação do
				ESTABELECIMENTO, com a negociação das condições comerciais, que poderá ser formalizada por
				meio eletrônico, em papel, aceite de voz ou por qualquer outro meio que vier a ser disponibilizado
				pela LUCREE
			</p>

			<p style={{ textAlign: 'justify' }}>
				3. O efetivo credenciamento e a adesão do ESTABELECIMENTO ao SISTEMA LUCREE está
				condicionado à aceitação prévia da LUCREE, mediante apresentação pelo ESTABELECIMENTO,
				quando necessário, dos documentos solicitados pela LUCREE, que fará a análise das atividades
				desenvolvidas pelo ESTABELECIMENTO, da sua saúde financeira e de seus
				sócios/representantes/proprietários/acionistas, do histórico de relacionamento anterior com a
				LUCREE, dentre outros critérios de análise cadastral e financeira que venham a ser adotados pela
				LUCREE, a qualquer tempo, inclusive durante a vigência deste CONTRATO.
			</p>
			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				3.1. A relação de documentos solicitados pela LUCREE será informada no momento do
				credenciamento.
			</p>
			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				3.2. Determinados ESTABELECIMENTOS não serão credenciados ou serão descredenciados
				pela LUCREE por exercerem atividades consideradas ilegais ou indesejáveis. O rol destas
				atividades está disponível para consulta no PORTAL DE SERVIÇOS LUCREE ou através da CENTRAL
				DE ATENDIMENTO.
			</p>
			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				3.3. O ESTABELECIMENTO se compromete a não efetuar TRANSAÇÕES em segmentos ou
				ramos de atividades diversos daqueles informados pelo ESTABELECIMENTO no momento de seu
				credenciamento na LUCREE, mesmo que tais atividades constem de seu objeto social. Qualquer
				alteração no segmento de atuação ou no ramo de atividade do ESTABELECIMENTO deve ser
				informada à LUCREE, que em caso de aprovação, efetuará a alteração cadastral, ficando o
				ESTABELECIMENTO ciente que tal alteração pode levar a uma nova negociação comercial.
			</p>

			<p style={{ textAlign: 'justify' }}>
				4. Após a aceitação e inclusão do ESTABELECIMENTO no SISTEMA LUCREE são gerados,
				automaticamente:
			</p>
			<p style={{ textAlign: 'justify' }}>
				(a)  o NÚMERO DE PV;
			</p>
			<p style={{ textAlign: 'justify' }}>
				(b)  o envio de uma correspondência, via Correios ou por meio eletrônico, com os dados cadastrais
					do ESTABELECIMENTO, e demais informações, tais como: DOMICÍLIO BANCÁRIO, valor da TAXA
					DE DESCONTO e/ou da TARIFA POR TRANSAÇÃO, valor do aluguel mensal do EQUIPAMENTO, se
					for o caso, os prazos de pagamento da LUCREE, informações estas que deverão ser devidamente
					conferidas pelo ESTABELECIMENTO quando do recebimento da referida correspondência, e em
					caso de divergência, o ESTABELECIMENTO deverá imediatamente entrar em contato pela
					CENTRAL DE ATENDIMENTO solicitando a regularização;
			</p>
			<p style={{ textAlign: 'justify' }}>
				(c)  a ordem de instalação e/ou homologação, e/ou fornecimento do número lógico do
					EQUIPAMENTO contratado.
			</p>
			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					4.1. O presente CONTRATO passa a vigorar a partir do momento que o ESTABELECIMENTO
					estiver apto e habilitado a realizar TRANSAÇÕES, independentemente de realizá-las.
				</p>
				<p>
					4.2. A ocorrência dos eventos acima implica a concordância do ESTABELECIMENTO com
					todos os termos e condições deste CONTRATO, bem como com as regras e exigências
					determinadas pela LUCREE, pelo ADQUIRENTE e pelas BANDEIRAS, pelo mercado de meios de
					pagamento e pela legislação, tenham sido elas estipuladas no passado ou venham ser no futuro,
					sendo que seu descumprimento pode acarretar na rescisão deste CONTRATO.
				</p>
				<p>
					4.3.  O ESTABELECIMENTO poderá vincular um ou mais PONTOS DE VENDAS (PV), sob sua
					responsabilidade, ao seu cadastro no SISTEMA LUCREE. A LUCREE avaliará o pedido conforme
					seus próprios critérios, podendo aprová-lo ou recusá-lo.
				</p>
				<p>
					4.4.  O ESTABELECIMENTO deverá providenciar a divulgação do CONTRATO às suas filiais,
					impondo-lhes a estrita observância de seus termos e condições.
				</p>
				<p>
					4.5.  Será permitido ao ESTABELECIMENTO, a qualquer momento, solicitar a adesão ou o
					cancelamento de determinados PRODUTOS, detalhados nos respectivos instrumentos específicos
					disponíveis no PORTAL DE SERVIÇOS LUCREE.
				</p>
				<p>
					4.6.  Os PRODUTOS disponíveis no SISTEMA LUCREE podem ser oferecidos ao
					ESTABELECIMENTO de forma remota, ou seja, sem que haja necessidade de uma visita ao
					ESTABELECIMENTO, sendo que a adesão do ESTABELECIMENTO se efetuará quando da realização
					de qualquer TRANSAÇÃO do PRODUTO ou mediante habilitação pela LUCREE, conforme o caso,
					o que resulta na aceitação de todos os termos e condições do instrumento específico que faz
					parte deste CONTRATO.
				</p>
			</p>

			<p style={{ textAlign: 'justify' }}>
				5.  É obrigação do ESTABELECIMENTO sinalizar suas instalações com os MATERIAIS fornecidos pela
				LUCREE, em locais de destaque e de boa visibilidade, para exposição ao público em geral, conforme
				orientações da LUCREE e observada a legislação em vigor.
			</p>

			<p style={{ textAlign: 'justify' }}>
				6.  O ESTABELECIMENTO autoriza a LUCREE, sempre que esta julgar necessário, a vistoriar durante
				o horário de funcionamento do ESTABELECIMENTO, diretamente ou por terceiros por ela designados,
				(i) a regularidade e permanência de suas atividades, nos termos da Cláusula 3.3 deste CONTRATO, (ii)
				a adequação da sinalização de uso obrigatório, nos termos da Cláusula 5 deste CONTRATO, (iii) a
				regularidade na realização das TRANSAÇÕES, (iv) o funcionamento dos EQUIPAMENTOS, e (v) a
				adequada guarda, o consumo e o abastecimento de todo e qualquer MATERIAL necessário à
				realização das TRANSAÇÕES.
			</p>

			<p><b>FORMA DE COBRANÇA DO ESTABELECIMENTO</b></p>

			<p style={{ textAlign: 'justify' }}>
				7. Além da TAXA DE DESCONTO e/ou TARIFA POR TRANSAÇÃO, a LUCREE poderá cobrar do
				ESTABELECIMENTO os seguintes encargos e taxas, sem prejuízo das cobranças específicas dos
				PRODUTOS e quaisquer outras taxas, tarifas e encargos eventualmente incidentes sobre este
				CONTRATO:
			</p>

			<p style={{ textAlign: 'justify' }}>
				(a)  ALUGUEL DE EQUIPAMENTO – valor mensal cobrado pelo aluguel dos EQUIPAMENTOS de
				propriedade da LUCREE disponibilizados ao ESTABELECIMENTO, conforme o caso;
			</p>
			<p style={{ textAlign: 'justify' }}>
				(b)  TAXA DE CONECTIVIDADE – valor mensal cobrado pela conectividade de ESTABELECIMENTOS
				que utilizem PDV/TEF ou outro PRODUTO para o qual tal taxa seja aplicável;
			</p>
			<p style={{ textAlign: 'justify' }}>
				(c)  INDENIZAÇÃO POR EQUIPAMENTO PERDIDO – valor cobrado por EQUIPAMENTOS da LUCREE
				ou de terceiros que não foram devolvidos para a LUCREE de acordo com as condições deste
				CONTRATO;
			</p>
			<p style={{ textAlign: 'justify' }}>
				(d)  TARIFA DE EMISSÃO DE EXTRATO – valor cobrado pela solicitação de 2ª via ou pela emissão de
				extrato em papel, a partir do momento do credenciamento, a menos que o ESTABELECIMENTO
				comunique a LUCREE o seu interesse em não receber o extrato em papel;
			</p>
			<p style={{ textAlign: 'justify' }}>
				(e)  TAXA DE ADESÃO – valor pago pelo ESTABELECIMENTO, após seu credenciamento ou
				recredenciamento ao SISTEMA LUCREE.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					7.1. A TARIFA POR TRANSAÇÃO poderá ser cobrada isoladamente ou em conjunto com a TAXA
					DE DESCONTO. O ESTABELECIMENTO poderá pagar diferentes TARIFAS POR TRANSAÇÃO e/ou
					TAXAS DE DESCONTO, dependendo da modalidade de TRANSAÇÃO, da atividade exercida e/ou
					da BANDEIRA capturada.
				</p>
				<p>
					7.2. A LUCREE poderá cobrar TAXA DE DESCONTO ou TARIFA POR TRANSAÇÃO diferenciadas,
					conforme o ESTABELECIMENTO.
				</p>
				<p>
					7.3. As taxas, preços e tarifas poderão ser reajustadas anualmente ou na menor periodicidade
					permitida em lei, pela variação do IPC/FGV no período, ou por qualquer outro índice que vier a
					substituí-lo. As taxas e preços fixadas em percentual do valor da TRANSAÇÃO não serão
					alcançadas pela regra desta Cláusula 7.3.
				</p>
				<p>
					7.4. A LUCREE poderá instituir novas modalidades de remuneração pelos seus serviços prestados,
					tais como tarifas ou taxas: (i) pela utilização dos seus recursos de atendimento; (ii) pelo
					fornecimento e reposição de MATERIAIS e insumos; (iii) pela instalação, reposição, manutenção
					e/ou fornecimento adicional de EQUIPAMENTOS; (iv) pela emissão de extratos, relatórios e
					borderôs; (v) por pesquisa de dados ou documentos; (vi) por recuperação de documentos e
					outras solicitações do ESTABELECIMENTO; (vii) por serviços especiais; (viii) pela manutenção de
					ESTABELECIMENTO inativo ao SISTEMA LUCREE; (ix) pela operacionalização, administração e
					controle de cada bloqueio de créditos do ESTABELECIMENTO, decorrentes de ofícios e/ou
					mandados de penhora, originados de autoridades judiciárias; e (x) por programas de incentivos e
					pacotes de PRODUTOS, objetivando incrementar a utilização dos CARTÕES e MEIOS DE
					PAGAMENTO junto aos ESTABELECIMENTOS.
				</p>
			</p>


			<p style={{ textAlign: 'justify' }}>
				8. Para a cobrança dos valores devidos pelo ESTABELECIMENTO, a LUCREE poderá adotar, a seu
				exclusivo critério, qualquer das seguintes alternativas:
			</p>

			<p style={{ textAlign: 'justify' }}>
				(a)  compensar o valor do débito com quaisquer outros créditos, presentes ou futuros, devidos ao
				ESTABELECIMENTO;
			</p>
			<p style={{ textAlign: 'justify' }}>
				(b)  realizar lançamentos a débito na conta do DOMICÍLIO BANCÁRIO do ESTABELECIMENTO;
			</p>
			<p style={{ textAlign: 'justify' }}>
				(c)  permitir que o ESTABELECIMENTO, no caso de ausência de créditos a compensar ou na
				impossibilidade de lançamento a débito em conta de livre movimentação, efetue, desde que
				acordado com a LUCREE, o pagamento mediante cheque, ordem de pagamento, DOC, TED, boleto
				bancário ou depósito identificado; ou
			</p>
			<p style={{ textAlign: 'justify' }}>
				(d) efetuar cobrança, judicial ou extrajudicial, através de escritório especializado.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					8.1.  A falta, parcial ou total, ou o atraso do pagamento, nos prazos acordados no CONTRATO e
					respectivas alterações, poderá sujeitar o ESTABELECIMENTO ao pagamento dos seguintes
					encargos adicionais, sem prejuízo da inclusão dos débitos do ESTABELECIMENTO no cadastro de
					Pendências Financeiras (PEFIN) dos órgãos de proteção ao crédito: (i) atualização monetária com
					base no IPC/FGV ou, na falta deste, por outro índice que legalmente o substitua; e (ii) juros de 1%
					(um por cento) a.m. “pro rata die”.
				</p>
				<p>
					8.2.  O ESTABELECIMENTO está ciente que, mediante a adesão ao SISTEMA LUCREE, autoriza que
					o banco de seu DOMICÍLIO BANCÁRIO efetue lançamentos a débito, crédito e outros previstos
					neste CONTRATO, em sua conta de livre movimentação, independente de prévia consulta ou de
					qualquer ato ou formalidade legal ou documental. Caso o banco de seu DOMICÍLIO BANCÁRIO se
					declare impedido de dar cumprimento às ordens de débito emitidas, a LUCREE estará autorizada
					a reter o pagamento dos créditos até o recebimento de comunicação e regularização do
					DOMICÍLIO BANCÁRIO pelo ESTABELECIMENTO ou a respectiva compensação do débito.
				</p>
				<p>
					8.3.  O ESTABELECIMENTO se compromete a ressarcir a LUCREE, nas formas de cobrança descritas
					nesta Cláusula 8, de todo e qualquer prejuízo comprovadamente sofrido pela LUCREE, em virtude
					de multas e/ou penalidades aplicadas pelos ADQUIRENTES, pelas BANDEIRAS, pelos EMISSORES
					ou pelas autoridades governamentais em razão do descumprimento pelo ESTABELECIMENTO das
					regras e exigências previstas no presente CONTRATO.
				</p>
			</p>

			<p><b>PAGAMENTO DAS TRANSAÇÕES AO ESTABELECIMENTO</b></p>

			<p style={{ textAlign: 'justify' }}>
				9.  O ESTABELECIMENTO está ciente e autoriza a LUCREE a fazer o pagamento do VALOR LÍQUIDO
				das TRANSAÇÕES, na forma e prazos definidos e cadastrados na LUCREE, mediante crédito do
				respectivo valor no DOMICÍLIO BANCÁRIO indicado pelo ESTABELECIMENTO, bem como por qualquer
				outro meio de pagamento admitido por este CONTRATO ou acordado entre as Partes, aí incluída a
				compensação, desde que a TRANSAÇÃO tenha sido realizada de acordo com o previsto neste
				CONTRATO.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					9.1.  O prazo de pagamento será contado a partir da data da apresentação do RESUMO DE
					VENDAS ao ESTABELECIMENTO ou a partir da data do recebimento do protocolo de
					TRANSAÇÕES efetuadas na modalidade TRANSMISSÃO DE ARQUIVOS ou TRANSAÇÃO OFF-
					LINE.
				</p>
				<p>
					9.2.  O ESTABELECIMENTO deverá zelar pela regularidade do DOMICÍLIO BANCÁRIO, bem como
					pela correção das informações prestadas à LUCREE. Caso o banco depositário do DOMICÍLIO
					BANCÁRIO se declare impedido, por qualquer motivo, de dar cumprimento às ordens de
					crédito emitidas pela LUCREE, deverá o ESTABELECIMENTO providenciar a regularização do
					DOMICÍLIO BANCÁRIO ou, ainda, indicar novo domicílio, informando tal providência à
					LUCREE, que estará autorizada a reter o pagamento dos créditos até a regularização do
					DOMICÍLIO BANCÁRIO, sem quaisquer ônus, penalidades ou encargos e à providenciar o
					bloqueio e a retirada do EQUIPAMENTO caso o DOMICÍLIO BANCÁRIO não seja regularizado
					pelo ESTABELECIMENTO, no prazo concedido pela LUCREE.
				</p>
				<p>
					9.3.  Se a data prevista para o crédito do VALOR LÍQUIDO da TRANSAÇÃO recair em feriado ou
					em dia de não funcionamento bancário na praça da sede da LUCREE ou na praça de
					compensação do DOMICÍLIO BANCÁRIO do ESTABELECIMENTO, o pagamento será realizado
					no primeiro dia útil subsequente.
				</p>
				<p>
					9.4.  A falta, parcial ou total, ou o atraso do pagamento nos prazos acordados, poderá sujeitar a
					LUCREE ao pagamento dos seguintes encargos adicionais:
				</p>
				<p>
					(a)  atualização monetária com base no IPC/FGV ou, na falta deste, por outro índice que
					legalmente o substitua; e
				</p>
				<p>
					(b)  juros de 1% (um por cento) a.m. “pro rata die”.
				</p>
				<p>
					9.5.  Salvo pelo previsto na Cláusula 9.7 abaixo, o ESTABELECIMENTO poderá solicitar a alteração
					de seu DOMICÍLIO BANCÁRIO, obrigando-se a LUCREE a efetuar a alteração no prazo de até
					10 (dez) dias úteis contados do recebimento da solicitação do ESTABELECIMENTO, sendo
					que os pagamentos relativos às TRANSAÇÕES capturadas anteriormente à alteração
					efetuada poderão ser creditados no DOMICÍLIO BANCÁRIO vigente na data da captura.
				</p>
				<p>
					9.6. É vedado ao ESTABELECIMENTO alterar o seu DOMICÍLIO BANCÁRIO caso tenha contratado
					a manutenção do seu DOMICÍLIO BANCÁRIO com uma instituição bancária.
				</p>
				<p>
					9.7. A informação de manutenção do DOMICÍLIO BANCÁRIO será comunicada à LUCREE pela
					própria instituição bancária ou por entidade independente que venha a centralizar tal
					informação.
				</p>
				<p>
					9.8. Com relação a manutenção de domicílio bancário, o ESTABELECIMENTO desde já concorda
					que: (i) a LUCREE poderá enviar as informações necessárias para que a entidade
					independente centralize tais informações; e (ii) a manutenção do DOMICÍLIO BANCÁRIO
					estará vinculada às TRANSAÇÕES de determinada BANDEIRA.
				</p>
				<p>
					9.9. A LUCREE poderá enviar periodicamente, à instituição financeira do DOMICÍLIO BANCÁRIO
					do ESTABELECIMENTO, a agenda contendo a previsão de recebíveis decorrentes de
					TRANSAÇÕES do ESTABELECIMENTO.
				</p>
			</p>

			<p style={{ textAlign: 'justify' }}>
				10. Nos casos em que se verificar a iliquidez, insolvência, pedido de recuperação judicial ou
				extrajudicial, estado pré-falimentar, encerramento de atividades ou qualquer outra hipótese em que
				ficar caracterizada a dificuldade do ESTABELECIMENTO em cumprir suas obrigações contratuais e/ou
				legais, a LUCREE se reserva o direito de reter os créditos a ele devidos, a fim de garantir o
				cumprimento de suas obrigações previstas neste CONTRATO e a segurança do mercado de meios de
				pagamentos.
			</p>

			<p style={{ textAlign: 'justify' }}>
				11. O ESTABELECIMENTO terá o prazo de 45 (quarenta e cinco) dias, a contar da data prevista para
				a realização do pagamento pela LUCREE, para apontar qualquer eventual divergência em relação aos
				valores pagos e/ou debitados do ESTABELECIMENTO. Findo tal prazo, não caberá nenhuma outra
				reclamação por parte do ESTABELECIMENTO, ocorrendo a quitação automática e definitiva quanto
				aos referidos valores
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					11.1. Excepcionalmente, a LUCREE, a seu exclusivo critério, mediante cobrança de tarifa específica
					de pesquisa, poderá, findo o prazo estipulado acima e respeitados os prazos de cobrança
					estipulados em Lei, verificar a existência de divergência nos créditos ou débitos apontados
					pelo ESTABELECIMENTO e, conforme o caso, efetuar os créditos ou débitos em seu
					DOMICÍLIO BANCÁRIO.
				</p>
				<p>
					11.2. A LUCREE poderá disponibilizar ao ESTABELECIMENTO o extrato das TRANSAÇÕES,
					mediante acesso em seu PORTAL DE SERVIÇOS LUCREE. Se o ESTABELECIMENTO preferir
					receber o extrato via troca eletrônica de arquivos (EDI – Eletronic Data Interchange), deverá
					solicitá-lo formalmente à LUCREE, e ainda contratar empresa especializada na entrega de
					tais arquivos e que esteja homologada na LUCREE e ainda um conciliador para a leitura
					destes arquivos, ficando a critério da LUCREE o fornecimento desse tipo de extrato.
				</p>
				<p>
					11.3. Caso a LUCREE, por equívoco ou qualquer outra razão, venha a realizar depósitos a maior
					no DOMICÍLIO BANCÁRIO do ESTABELECIMENTO, este fica obrigado a de forma imediata, a
					partir do momento em que tomar ciência do depósito a maior, ou mesmo a partir do
					momento em que for possível ao ESTABELECIMENTO verificar a existência de depósito a
					maior, realizar a devolução dos valores depositados em excesso, autorizando igualmente a
					LUCREE, nos termos da cláusula 8.2, a realizar lançamentos a débito na conta de livre
					movimentação para solução destes casos.
				</p>
			</p>

			<p><b>EQUIPAMENTOS</b></p>

			<p style={{ textAlign: 'justify' }}>
				12. A LUCREE poderá fornecer ao ESTABELECIMENTO, conforme o caso, os EQUIPAMENTOS de sua
				propriedade bem como homologar os EQUIPAMENTOS de propriedade do ESTABELECIMENTO ou
				de terceiros para integração ao SISTEMA LUCREE.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					12.1. Os EQUIPAMENTOS são fornecidos ao ESTABELECIMENTO com as devidas orientações
					para manuseio. Em caso de dúvidas, o ESTABELECIMENTO tem à disposição o manual de utilização
					disponibilizado na instalação do EQUIPAMENTO e/ou disponível no PORTAL DE SERVIÇOS
					LUCREE, ou ainda poderá entrar em contato com a CENTRAL DE ATENDIMENTO.
				</p>
				<p>
					12.2. A instalação e desinstalação do EQUIPAMENTO pode ser realizada pela LUCREE ou por terceiros por ela indicados, no endereço cadastrado na LUCREE.
				</p>
				<p>
					12.3. O ESTABELECIMENTO deve se responsabilizar pelo tipo de EQUIPAMENTO que seja
					obrigado a utilizar em virtude da legislação específica, bem como pelo pagamento de todos os
					tributos e contribuições decorrentes da utilização do EQUIPAMENTO, não se responsabilizando a
					LUCREE, por meio deste CONTRATO, por qualquer situação que venha a ser imposta em função
					da escolha e utilização do EQUIPAMENTO pelo ESTABELECIMENTO, ficando o ESTABELECIMENTO
					ciente de que, em caso de desrespeito ao aqui previsto, será o responsável e arcará com os riscos
					decorrentes de tal inobservância, dentre os quais se incluem, mas não se limitam, aos riscos legais
					e fiscais.
				</p>
			</p>

			<p style={{ textAlign: 'justify' }}>
				13. Em relação aos EQUIPAMENTOS, o ESTABELECIMENTO se obriga a:
			</p>

			<p style={{ textAlign: 'justify' }}>(a) no caso de TERMINAIS POS com fio, tornar disponíveis linhas telefônicas para instalação e uso dos EQUIPAMENTOS, arcando com as respectivas tarifas e com os custos e despesas de funcionamento, relativos ao consumo de energia elétrica, transmissão dos dados bem como outros custos e despesas relacionados ao uso da linha telefônica;</p>

			<p style={{ textAlign: 'justify' }}>(b) conferir, no momento da instalação ou manutenção do EQUIPAMENTO, os dados cadastrais impressos no COMPROVANTE DE VENDA emitido pelo EQUIPAMENTO;</p>

			<p style={{ textAlign: 'justify' }}>
				(c) usar os EQUIPAMENTOS e PERIFÉRICOS corretamente, respondendo pelos custos de instalação,
				conserto e manutenção dos EQUIPAMENTOS de sua propriedade, bem como, pelos custos de
				instalação, conserto e manutenção dos EQUIPAMENTOS de propriedade da LUCREE, na hipótese de
				sua quebra ou falha ou decorrentes de uso e/ou instalação e/ou manuseio indevidos por seus
				empregados ou prepostos, sendo que a instalação, conserto e manutenção serão efetuados pela
				LUCREE;
			</p>

			<p style={{ textAlign: 'justify' }}>(d) não ceder, sublocar, transferir ou alienar, total ou parcialmente, os EQUIPAMENTOS de propriedade da LUCREE, sem a anuência da LUCREE, ficando o ESTABELECIMENTO ciente de que, em caso de desrespeito ao aqui previsto, será o responsável e arcará com os riscos decorrentes de tal inobservância, dentre os quais se incluem, mas não se limitam, aos riscos legais e fiscais; </p>

			<p style={{ textAlign: 'justify' }}>(e) adotar todas as providências e cautelas necessárias para manter a guarda, a integridade e a perfeita conservação e funcionamento dos EQUIPAMENTOS de propriedade da LUCREE, sendo vedado ao ESTABELECIMENTO realizar qualquer reparação ou modificação em tais EQUIPAMENTOS, comprometendo-se a comunicar imediatamente à LUCREE qualquer intervenção ou violação por terceiros de quaisquer dos seus direitos relativamente ao EQUIPAMENTO;</p>

			<p style={{ textAlign: 'justify' }}>(f) reconhecer e concordar que os softwares aplicativos cedidos ou inseridos nos EQUIPAMENTOS,de forma gratuita ou onerosa pela LUCREE, são de titularidade da LUCREE ou de terceiros e incorporam a propriedade intelectual da LUCREE ou de tais terceiros, podendo o ESTABELECIMENTO apenas fazer uso deles, comprometendo-se a não ceder, copiar, alterar, modificar, adaptar, manipular, adicionar, descompilar, decompor ou efetuar qualquer conversão dos softwares, sendo vedado também o uso de engenharia reversa ou utilização para fins diversos dos previstos no presente CONTRATO, sob pena de imediata rescisão do CONTRATO, sem prejuízo do ressarcimento por eventuais perdas e danos acarretados;</p>

			<p style={{ textAlign: 'justify' }}>(g) assumir a responsabilidade pelo pagamento do valor do EQUIPAMENTO de propriedade da LUCREE nos seguintes casos: furto, roubo, perda total ou parcial, incêndio, destruição total ou parcial, falta de solicitação de assistência técnica, descuido no manuseio, retenção ou qualquer outro fato ou evento que impossibilite, dificulte ou prejudique o direito de propriedade sobre os EQUIPAMENTOS por parte da LUCREE, além da responsabilidade pela apreensão, remoção, bloqueio, lacre, confisco ou leilão dos EQUIPAMENTOS por quaisquer órgãos ou autoridades, desde que tenha dado causa a tais eventos, e pelo custo de reparo, substituição ou liberação, bem como eventuais multas e penalidades impostas;</p>

			<p style={{ textAlign: 'justify' }}>(g.1) Em casos de furto ou roubo, incêndio ou destruição total ou parcial, o ESTABELECIMENTOdeverá apresentar à LUCREE o respectivo Boletim de Ocorrência ou laudo específico, onde deve constar, obrigatoriamente, dados que identifiquem o EQUIPAMENTO;</p>

			<p style={{ textAlign: 'justify' }}>(h) comunicar imediatamente à LUCREE caso haja suspeita de fraude ou fraude confirmada no EQUIPAMENTO.</p>

			<p style={{ textAlign: 'justify' }}>
				14. O ESTABELECIMENTO pode utilizar EQUIPAMENTO, software, hardware e materiais relacionados, de sua propriedade ou de terceiros por ele contratados, desde que homologados pela LUCREE, e nesta hipótese, quaisquer substituições ou alterações relativas aos EQUIPAMENTOS, softwares, hardwares devem ser submetidas à aprovação prévia da LUCREE.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					14.1. O ESTABELECIMENTO é o único responsável pela adequação dos EQUIPAMENTOS,
					software, hardware e materiais de sua propriedade ou de terceiros, utilizados nas operações do
					SISTEMA LUCREE, bem como pela conexão, instalação, manuseio, manutenção e abastecimento
					dos mesmos, e ainda pelo treinamento e obtenção das necessárias licenças e autorizações,
					respondendo isoladamente por esses custos, ou por quaisquer eventos, ônus ou encargos
					decorrentes da utilização inadequada ou ineficiente de tais EQUIPAMENTOS, software, hardware
					e materiais relacionados.
				</p>
				<p>
					14.2. O ESTABELECIMENTO deve cumprir e manter-se aderente às regras dos ADQUIRENTES
					e das BANDEIRAS e às regras do mercado de meios de pagamento, devendo, quando for o caso,
					adequar os padrões de funcionamento de seus EQUIPAMENTOS, aos novos padrões, nos prazos
					e condições estabelecidas pela LUCREE. Em caso de não adequação, a LUCREE fica isenta de
					quaisquer responsabilidades relativas a indícios ou suspeitas de fraude, em todas as TRANSAÇÕES
					com CARTÕES e MEIOS DE PAGAMENTO, devendo o ESTABELECIMENTO arcar com quaisquer
					prejuízos que comprovadamente vierem a ser ocasionados à LUCREE, ao próprio
					ESTABELECIMENTO, a terceiros ou ainda eventuais multas cobradas pelos ADQUIRENTES e pelas
					BANDEIRAS.
				</p>
			</p>

			<p style={{ textAlign: 'justify' }}>
				15. A LUCREE providenciará a manutenção dos EQUIPAMENTOS de sua propriedade, se houver
				necessidade ou em caso de solicitação do ESTABELECIMENTO. A manutenção preventiva e corretiva
				só será realizada pela LUCREE nos EQUIPAMENTOS de sua propriedade, sendo de responsabilidade
				do ESTABELECIMENTO a manutenção do EQUIPAMENTO de sua propriedade.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					15.1. A manutenção pode ser realizada remotamente e, havendo necessidade de reparo
					físico, será feito o atendimento no local da instalação do EQUIPAMENTO, sendo atendido pela
					LUCREE ou por terceiros por ela indicados, dentro do horário de funcionamento do
					ESTABELECIMENTO
				</p>
				<p>
					15.2. O ESTABELECIMENTO deve facilitar o acesso dos técnicos aos locais de instalação dos EQUIPAMENTOS.
				</p>
			</p>

			<p style={{ textAlign: 'justify' }}>
				16. O ESTABELECIMENTO reconhece o direito da LUCREE de efetuar interrupções no fornecimento
				dos serviços e desde já declara que tem conhecimento pleno de que os serviços poderão,
				eventualmente, ser afetados, ou temporariamente interrompidos por motivos técnicos, em razão de
				reparo, manutenção ou troca de EQUIPAMENTO. A LUCREE não garante que seus serviços ficarão
				sem interrupção ou que estarão livres de erros.
			</p>

			<p style={{ textAlign: 'justify' }}>
				17. Serviços de tecnologia estão sujeitos a falhas e interrupções. Sendo assim, o ESTABELECIMENTO
				declara ciência e concorda que a LUCREE não se responsabiliza por eventuais falhas, atrasos ou
				interrupções na prestação de serviço, inclusive se decorrentes de caso fortuito ou motivos de força
				maior, nos termos da Cláusula 40 deste CONTRATO, bem como por limitações impostas por parte do
				Poder Público ou da atuação de operadoras de serviço de telecomunicações interconectadas à rede
				do ESTABELECIMENTO, ou, ainda, por má utilização do serviço pelo ESTABELECIMENTO ou por
				qualquer outro fato alheio à LUCREE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				18. O ESTABELECIMENTO pode solicitar a qualquer momento o cancelamento do seu cadastro e a
				desinstalação dos EQUIPAMENTOS. Ao término ou rescisão do CONTRATO, o ESTABELECIMENTO se
				compromete a devolver o EQUIPAMENTO de propriedade da LUCREE, com seus respectivos
				PERIFÉRICOS, no mesmo estado em que os recebeu, salvo desgaste natural pelo uso.
			</p>

			<p><b>REALIZAÇÃO DAS TRANSAÇÕES</b></p>

			<p style={{ textAlign: 'justify' }}>19. No momento da realização da TRANSAÇÃO, o ESTABELECIMENTO deve, obrigatoriamente:</p>

			<p style={{ textAlign: 'justify' }}>(a) verificar se o prazo de validade do CARTÃO não está vencido ou se o CARTÃO não está adulterado ou rasurado;</p>

			<p style={{ textAlign: 'justify' }}> (b) conferir, em casos de CARTÃO sem CHIP e/ou quando não houver digitação de SENHA, o nome e a assinatura do PORTADOR lançada no COMPROVANTE DE VENDA, com o nome e a assinatura constantes do CARTÃO ou documento de identificação do PORTADOR; </p>

			<p style={{ textAlign: 'justify' }}>(c) comparar os últimos 4 (quatro) dígitos do número do CARTÃO, com os dígitos impressos no COMPROVANTE DE VENDAS;</p>

			<p style={{ textAlign: 'justify' }}>(d) conferir a existência do código de segurança, formado por três dígitos, no verso do CARTÃO;</p>

			<p style={{ textAlign: 'justify' }}>(e) observar as características de segurança utilizadas pelas BANDEIRAS, como hologramas tridimensional, marcas de segurança, letras estilizadas, dentre outras;</p>

			<p style={{ textAlign: 'justify' }}>(f) cumprir todos os procedimentos, padrões e normas exigidas neste CONTRATO, sendo que a LUCREE não se responsabilizará pelas TRANSAÇÕES concluídas em desacordo com o aqui disposto; e</p>

			<p style={{ textAlign: 'justify' }}>(g) orientar os PORTADORES sobre a melhor condição de pagamento para aquisição de bens e/ou serviços, de forma clara e objetiva, a fim de que estes façam opção consciente do uso do CARTÃO.</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					19.1. Nas TRANSAÇÕES realizadas com CARTÕES com CHIP, o ESTABELECIMENTO deve efetuar a leitura do CHIP no EQUIPAMENTO.
				</p>
			</p>

			<p style={{ textAlign: 'justify' }}>
				20. O ESTABELECIMENTO está impedido de impor condições e/ou restrições ao pleno uso e à
				aceitação de CARTÕES e MEIOS DE PAGAMENTO, sendo-lhe expressamente vedado efetuar qualquer
				discriminação relativamente a quaisquer EMISSORES ou BANDEIRAS.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					20.1. O ESTABELECIMENTO deverá praticar preços iguais aos praticados nas vendas
					realizadas em dinheiro, cheque, boleto ou outros meios de pagamento, sem acréscimo de
					quaisquer encargos ou taxas de qualquer natureza, oferecendo aos PORTADORES as mesmas
					condições e/ou vantagens promocionais oferecidas a quaisquer outros meios ou formas de
					pagamento diferentes dos CARTÕES.
				</p>
				<p>
					20.2. Excepcionalmente, sob condições especiais previamente ajustadas com a LUCREE, o
					ESTABELECIMENTO poderá oferecer vantagens promocionais, por prazo determinado, para o
					público-alvo dos CARTÕES e MEIOS DE PAGAMENTO.
				</p>
			</p>

			<p style={{ textAlign: 'justify' }}>
				21. O ESTABELECIMENTO deve utilizar os EQUIPAMENTOS somente para realizar TRANSAÇÕES
				regulares, estritamente de acordo com normas e condições deste CONTRATO, sendo vedado ao
				ESTABELECIMENTO aceitar os CARTÕES e MEIOS DE PAGAMENTO em TRANSAÇÕES fictícias ou
				simuladas, tais como, mas não limitadas a:
			</p>

			<p style={{ textAlign: 'justify' }}>(a) realizar TRANSAÇÕES com a finalidade de garantia ou caução, sem a devida autorização da LUCREE;</p>

			<p style={{ textAlign: 'justify' }}>(b) efetuar TRANSAÇÕES não relacionadas com o ramo de atividade do ESTABELECIMENTO cadastrado na LUCREE;</p>

			<p style={{ textAlign: 'justify' }}>(c) desmembrar uma única venda em duas ou mais TRANSAÇÕES no mesmo CARTÃO;</p>

			<p style={{ textAlign: 'justify' }}>(d) fornecer ou restituir aos PORTADORES, por qualquer motivo, quantias em dinheiro (moeda nacional ou estrangeira, cheques, ordens de pagamento ou títulos de crédito), salvo nas hipóteses previstas pela LUCREE neste CONTRATO;</p>

			<p style={{ textAlign: 'justify' }}>(e) qualquer outro tipo ou forma de TRANSAÇÕES consideradas irregulares e decorrentes de atividades consideradas ilegais ou indesejáveis, conforme estabelecido pela LUCREE, pelos EMISSORES e pelas BANDEIRAS; </p>

			<p style={{ textAlign: 'justify' }}>(f) aceitar CARTÃO de titularidade de terceiros;</p>

			<p style={{ textAlign: 'justify' }}>(g) utilizar os EQUIPAMENTOS, sem autorização prévia da LUCREE ou utilizar o EQUIPAMENTO de outro ESTABELECIMENTO.</p>

			<p style={{ textAlign: 'justify' }}>
				22. Estão sujeitas ao não processamento ou não pagamento as TRANSAÇÕES irregularmente
				realizadas pelo ESTABELECIMENTO, sob quaisquer modalidades, de forma conivente ou não, em
				circunstâncias que caracterizem indícios ou suspeita de fraude que objetivem a obtenção de
				vantagens ilícitas ou estejam em desacordo com este CONTRATO. Os eventos mencionados nesta
				Cláusula estão sujeitos ao ressarcimento, pelo ESTABELECIMENTO, nos termos deste CONTRATO.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					22.1. Desta forma, a TRANSAÇÃO, mesmo após ser autorizada e processada, poderá ser
					cancelada pela LUCREE, a qualquer tempo, se for constatada a ocorrência de
					irregularidades e/ou de circunstâncias que caracterizem indícios ou suspeita de fraudes.
				</p>
			</p>

			<p style={{ textAlign: 'justify' }}>
				23. O ESTABELECIMENTO está ciente que será descredenciado caso atinja um percentual de
				TRANSAÇÕES suspeitas ou irregulares conforme definição das BANDEIRAS ou regras de
				monitoramento de fraude da LUCREE, bem como se atingir índices de CONTESTAÇÃO DE
				TRANSAÇÕES além dos limites estabelecidos pela LUCREE e/ou pelas BANDEIRAS, exceto se a LUCREE
				entender que é possível reverter a situação.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					23.1. Ocorridas as hipóteses acima, sem prejuízo de determinadas obrigações a serem assumidas
					pelo ESTABELECIMENTO, o ESTABELECIMENTO deverá ressarcir a LUCREE dos prejuízos
					causados e penalidades aplicadas, pelas formas de cobrança previstas no CONTRATO.
				</p>
				<p>
					23.2. O ESTABELECIMENTO está ciente e concorda com os métodos que a LUCREE vier a adotar
					para identificar e prevenir fraudes e práticas ilícitas, comprometendo-se o
					ESTABELECIMENTO a monitorar e orientar seus funcionários, bem como cooperar e
					colaborar, principalmente no fornecimento das informações solicitadas, sob pena de
					ressarcimento, pelo ESTABELECIMENTO, nos termos deste CONTRATO e rescisão do
					mesmo.
				</p>
			</p>

			<p style={{ textAlign: 'justify' }}>
				24. O ESTABELECIMENTO, na consecução de suas atividades e realização de TRANSAÇÕES, não
				poderá utilizar recursos tecnológicos, hardware, software ou qualquer outra tecnologia não
				homologada ou não autorizada pela LUCREE e/ou que venha a trazer riscos de fraude ou segurança
				para o SISTEMA LUCREE e que estejam em desacordo com as normas e padrões internacionais da
				indústria de CARTÕES. As TRANSAÇÕES, no âmbito do SISTEMA LUCREE, deverão ser capturadas,
				processadas, roteadas, liquidadas e compensadas apenas pela LUCREE ou pelos ADQUIRENTES,
				conforme o caso, ou por Câmara de Liquidação autorizada pelo Banco Central e contratada pela
				LUCREE, e também devem estar em consonância com normas, procedimentos e autorizações da
				BANDEIRA e do mercado de meios de pagamento.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					24.1.  Este CONTRATO não é o documento apropriado para regular a relação entre a LUCREE e
					ESTABELECIMENTOS que efetuem liquidação das TRANSAÇÕES. Desta forma,
					ESTABELECIMENTOS que queiram intermediar TRANSAÇÕES de terceiros deverão informar a
					LUCREE e assinar documento específico, ficando a relação entre tais ESTABELECIMENTOS e a
					LUCREE regulada pelo presente CONTRATO até que o documento específico seja assinado.
				</p>
				<p>
					24.2. O descumprimento desta Cláusula pelo ESTABELECIMENTO autorizará a LUCREE a rescindir
					este CONTRATO por justa causa, na forma da Cláusula 37, sem prejuízo do ressarcimento
					pelo ESTABELECIMENTO das perdas e danos resultantes para a LUCREE.
				</p>
			</p>

			<p style={{ textAlign: 'justify' }}>
				25. O ESTABELECIMENTO é o exclusivo responsável por solucionar, diretamente com os
				PORTADORES, toda e qualquer eventual controvérsia sobre as características, qualidade, quantidade,
				propriedades, origem, preço, funcionamento, garantias, defeitos e/ou avarias dos bens e produtos
				adquiridos e/ou serviços prestados, incluindo casos de defeito ou devolução, problemas de entrega
				etc. A LUCREE, as BANDEIRAS e o EMISSOR são isentos de quaisquer responsabilidades convencionais
				ou legais em relação aos fatos mencionados nesta Cláusula, inclusive com relação ao Código de
				Proteção e Defesa do Consumidor.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					25.1. O ESTABELECIMENTO está ciente e concorda expressamente que a responsabilidade da
					LUCREE se limita à execução das obrigações descritas neste CONTRATO, sendo certo que
					quaisquer obrigações ou ônus decorrentes, direta ou indiretamente, de quaisquer
					procedimentos administrativos ou judiciais, resultantes de eventual descumprimento de
					qualquer obrigação principal ou acessória por parte do ESTABELECIMENTO e promovida
					por qualquer órgão federal, estadual ou municipal competente, deverão ser suportados
					integralmente pelo ESTABELECIMENTO.
				</p>
				<p>
					25.2. Na hipótese de a LUCREE despender quaisquer valores em razão do disposto na Cláusula 25.1 acima, será aplicado o procedimento de cobrança previsto neste CONTRATO.
				</p>
				<p>
					25.3. O ESTABELECIMENTO autoriza expressamente a LUCREE, desde já, a lhe repassar quaisquer
					despesas legítimas para o cumprimento de ordem de terceiro com relação ao
					ESTABELECIMENTO, incluindo, sem limitar-se, atendimento de ofícios judiciais, bloqueios,
					penhoras e arrestos.
				</p>
			</p>

			{/*
						<p><b>EQUIPAMENTOS</b></p>

						<p style={{ textAlign: 'justify' }}>
							26. O ESTABELECIMENTO deve ser previamente autorizado pela LUCREE para realizar TRANSAÇÃO sem CARTÃO presente, assumindo total responsabilidade pela TRANSAÇÃO, inclusive em caso de CONSTESTAÇÃO DA TRANSAÇÃO e CANCELAMENTO DAS TRANSAÇÕES, que serão sempre debitadas dos ESTABELECIMENTOS, sem prejuízo do previsto na Cláusula 23 do presente CONTRATO.
						</p>

						<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
							<p>
								26.1. Na modalidade de TRANSAÇÃO acima, caso o PORTADOR não reconheça ou discorde do valor da TRANSAÇÃO perante o EMISSOR, a LUCREE deixará de efetuar o pagamento do valor da TRANSAÇÃO ao ESTABELECIMENTO ou, caso já o tenha feito, poderá adotar, a seu exclusivo critério, quaisquer das formas de cobrança previstas na Cláusula 8 deste CONTRATO, ainda que o ESTABELECIMENTO apresente qualquer documento que comprove a realização da TRANSAÇÃO, inclusive o COMPROVANTE DE VENDA com ou sem assinatura do PORTADOR.
							</p>
						</p>
			*/}

			{/*    PARTE NOVA DO CONTRATO    */}
			<p><b>TRANSAÇÕES SEM CARTÃO PRESENTE</b></p>

			<p style={{ textAlign: 'justify' }}>
				26. O ESTABELECIMENTO deve ser previamente autorizado pela LUCREE para realizar TRANSAÇÃO
				sem CARTÃO presente, assumindo total responsabilidade pela TRANSAÇÃO, inclusive em caso de
				CONSTESTAÇÃO DA TRANSAÇÃO e CANCELAMENTO DAS TRANSAÇÕES, que serão sempre debitadas
				dos ESTABELECIMENTOS, sem prejuízo do previsto na Cláusula 23 do presente CONTRATO.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					26.1. Na modalidade de TRANSAÇÃO acima, caso o PORTADOR não reconheça ou discorde do
					valor da TRANSAÇÃO perante o EMISSOR, a LUCREE deixará de efetuar o pagamento do valor da
					TRANSAÇÃO ao ESTABELECIMENTO ou, caso já o tenha feito, poderá adotar, a seu exclusivo
					critério, quaisquer das formas de cobrança previstas na Cláusula 8 deste CONTRATO, ainda que o
					ESTABELECIMENTO apresente qualquer documento que comprove a realização da TRANSAÇÃO,
					inclusive o COMPROVANTE DE VENDA com ou sem assinatura do PORTADOR.
				</p>
			</p>



			<p><b> CONTESTAÇÃO E CANCELAMENTO DE TRANSAÇÕES </b></p>

			<p style={{ textAlign: 'justify' }}>
				27. O ESTABELECIMENTO é o responsável pelo CHARGEBACK decorrente de TRANSAÇÃO originada
				a partir de suas atividades e submetida ao SISTEMA LUCREE. Na hipótese de CONTESTAÇÃO DA
				TRANSAÇÃO, a LUCREE receberá tal informação do EMISSOR e solicitará ao ESTABELECIMENTO,
				quando cabível, a comprovação da TRANSAÇÃO, sendo aplicáveis as condições abaixo, bem como a
				Política de Contestação e Cancelamento Lucree, disponível no PORTAL DE SERVIÇOS LUCREE, com a
				qual o ESTABELECIMENTO concorda e se obriga a observar e cumprir.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					27.1. Além dos documentos previstos na Política de Contestação e Cancelamento Lucree, o
					ESTABELECIMENTO deve, sempre que lhe for solicitado, enviar à LUCREE cópias legíveis e sem
					rasuras dos COMPROVANTES DE VENDAS, assinados ou não pelos PORTADORES, bem como
					qualquer documentação adicional que comprove a TRANSAÇÃO, dentro do prazo de 2 (dois) dias
					a contar da data da solicitação da LUCREE, ou em prazo maior eventualmente previsto na Política
					de Contestação e Cancelamento Lucree. Se o ESTABELECIMENTO não apresentar a cópia dos
					documentos mencionados acima no prazo fixado, estará sujeito ao não pagamento ou ao débito
					da respectiva TRANSAÇÃO.
				</p>
				<p>
					27.2. Para cumprimento do disposto acima, o ESTABELECIMENTO deve manter em arquivo
					a via original assinada ou não dos COMPROVANTES DE VENDAS, bem como de qualquer
					documentação adicional que comprove a TRANSAÇÃO, pelo prazo de 18 (dezoito) meses, a contar
					da data da TRANSAÇÃO.
				</p>
				<p>
					27.3. Os dados impressos no COMPROVANTE DE VENDAS têm vida útil de até 5 (cinco) anos,
					conforme informado no verso do COMPROVANTE DE VENDAS desde que se evite o contato direto
					com plásticos, solventes ou produtos químicos, bem como a exposição ao calor e umidade
					excessivos, à luz solar e à iluminação de lâmpadas fluorescentes. Para maior segurança,
					recomenda-se que o ESTABELECIMENTO tire cópias dos COMPROVANTES DE VENDAS, bem como
					de qualquer documentação de comprovação da entrega dos bens adquiridos ou da prestação de
					serviços realizada.
				</p>
			</p>

			<p style={{ textAlign: 'justify' }}>
				28. O ESTABELECIMENTO pode solicitar o CANCELAMENTO DAS TRANSAÇÕES na modalidade
				crédito no prazo de 30 (trinta) dias e o CANCELAMENTO DAS TRANSAÇÕES na modalidade débito no
				prazo de 2 (dois) dias, a contar da data da realização da respectiva TRANSAÇÃO.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					28.1. Se o ESTABELECIMENTO solicitar o cancelamento das TRANSAÇÕES antes do
					recebimento do valor da TRANSAÇÃO, a TRANSAÇÃO será cancelada e não será efetuado o
					respectivo pagamento.
				</p>
				<p>
					28.2. Se o ESTABELECIMENTO solicitar o cancelamento das TRANSAÇÕES e o pagamento da
					TRANSAÇÃO já tiver sido efetuado ao ESTABELECIMENTO, total ou parcialmente, mesmo que por
					antecipação, a LUCREE deverá ser restituída do valor da TRANSAÇÃO mediante compensação com
					valores de TRANSAÇÕES a serem liquidadas ou realização de depósito bancário pelo
					ESTABELECIMENTO.
				</p>
			</p>

			<p style={{ textAlign: 'justify' }}>
				29. Na hipótese das TRANSAÇÕES pendentes realizadas através do PDV/TEF o ESTABELECIMENTO
				deve confirmá-las ou desfazê-las, no prazo previamente informado pela LUCREE, por uma das formas
				de comunicação prevista neste CONTRATO. O descumprimento desse prazo pelo ESTABELECIMENTO
				implicará o desfazimento automático da respectiva TRANSAÇÃO, independente de qualquer
				comunicação por parte da LUCREE, devendo o ESTABELECIMENTO ressarcir a LUCREE pelos prejuízos
				causados em decorrência das TRANSAÇÕES pendentes.
			</p>

			<p><b>NEGOCIAÇÃO DOS CRÉDITOS DOS ESTABELECIMENTOS</b></p>

			<p style={{ textAlign: 'justify' }}>
				30. Os recebíveis oriundos das TRANSAÇÕES do ESTABELECIMENTO perante a LUCREE, e perante
				outras credenciadoras/subcrecenciadoras, estão sujeitos a registro conforme normas do Banco
				Central do Brasil e podem ser negociados. O ESTABELECIMENTO reconhece que qualquer caução,
				cessão, transferência de titularidade ou negociações envolvendo recebíveis decorrentes
				TRANSAÇÕES do ESTABELECIMENTO no Sistema Lucree serão ineficazes sem comunicação à LUCREE
				e sua concordância, exceto na eventualidade de prévia e escrita concordância da LUCREE
				diretamente ao ESTABELECIMENTO ou pelas regras do sistema de registro recebíveis, hipótese em
				que poderá haver cobrança de taxas pela LUCREE. A LUCREE está autorizada, pelo
				ESTABELECIMENTO, a repassar aos sistemas de registro qualquer informação sobre negociação de
				recebíveis do ESTABELECIMENTO, bem como a constituir ônus em suas unidades de recebíveis, para
				fins de garantir operações ou obrigações oriundas deste CONTRATO.
			</p>

			<p style={{ textAlign: 'justify' }}>
				30.1. O ESTABELECIMENTO autoriza a LUCREE, por tempo indeterminado:
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					(a) a consultar junto aos sistemas de registro, diretamente ou por meio de parceiros, todas as
					transações e recebíveis do ESTABELECIMENTO, vinculados à LUCREE e outras
					credenciadoras/subcredenciadoras;
				</p>
				<p>
					(b) a consultar, diretamente ou por meio de parceiros, a qualquer momento, o histórico de
					faturamento de recebíveis oriundos de transações com cartões de pagamento relativo ao período
					de 12 (doze) meses anteriores à data de cada consulta do ESTABELECIMENTO;
				</p>
				<p>
					(c) a consultar, por meio de instituições aptas, informações disponíveis nos sistemas do Banco Central
					do Brasil, a exemplo do Sistema de Informações de Créditos (SCR).
				</p>
			</p>

			<p style={{ textAlign: 'justify' }}>
				30.2. Todos os parceiros e outras instituições aptas citados ao longo da Cláusula 30.1 ficam também
				expressamente autorizados, pelo ESTABELECIMENTO, a repassar informações do ESTABELECIMENTO
				à LUCREE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				30.3. As autorizações concedidas pelo ESTABELECIMENTO na Cláusula 30.1 servirão para que a
				LUCREE possa lhe oferecer produtos e serviços, e poderão ser canceladas a qualquer momento por
				meio dos canais de atendimento da LUCREE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				30.4. Os recebíveis do ESTABELECIMENTO, mesmo após negociação, permanecem sujeitos aos
				termos deste CONTRATO, incluindo quanto a cancelamentos, estornos e CHARGEBACKS.
			</p>



			<p><b>CONFIDENCIALIDADE E SEGURANÇA DAS INFORMAÇÕES</b></p>

			<p style={{ textAlign: 'justify' }}>
				31. O ESTABELECIMENTO se compromete a manter em sigilo os dados ou especificações a que tiver
				acesso ou que venha a ter sobre TRANSAÇÕES, PORTADORES e condições estabelecidas neste
				CONTRATO
			</p>

			<p style={{ textAlign: 'justify' }}>
				32. A LUCREE prestará às autoridades competentes, tais como o Ministério da Fazenda, o Banco
				Central do Brasil, a Receita Federal, as Secretarias da Fazenda Estaduais e Municipais, Comissões
				Parlamentares de Inquérito, todas as informações que forem solicitadas em relação ao
				ESTABELECIMENTO ou quaisquer dados relativos às TRANSAÇÕES efetuadas nos
				ESTABELECIMENTOS.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					32.1. O ESTABELECIMENTO autoriza e concorda que a LUCREE poderá compartilhar com os seus controladores toda e qualquer informação do ESTABELECIMENTO.
				</p>
				<p>
					32.2. A LUCREE poderá comunicar ao COAF – Conselho de Controle de Atividades
					Financeiras, as TRANSAÇÕES que possam estar configuradas na Lei 9.613/98 e demais normas
					relativas à lavagem de dinheiro.
				</p>
				<p>
					32.3. O ESTABELECIMENTO autoriza e concorda que a LUCREE, os ADQUIRENTES, os
					EMISSORES, o DOMICÍLIO BANCÁRIO e as BANDEIRAS compartilhem suas informações cadastrais.
				</p>
			</p>

			<p style={{ textAlign: 'justify' }}>
				33. Caso o ESTABELECIMENTO trafegue, processe ou armazene em seu ambiente DADOS DO
				PORTADOR DE CARTÃO, seja em mídia física ou digital, este se compromete a cumprir e manterse aderente às regras emanadas pelo PCI (Payment Card Industry) ou qualquer norma posterior
				que venha a regular a segurança de DADOS DO PORTADOR DE CARTÃO no mercado de meios de
				pagamento, durante a vigência deste CONTRATO, conforme prazos e condições definidas pela
				LUCREE.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					33.1. A obrigatoriedade acima se estende a qualquer fornecedor contratado pelo
					ESTABELECIMENTO cuja atividade seja passível de tráfego, processamento ou armazenamento
					dos DADOS DO PORTADOR DE CARTÃO.
				</p>
				<p>
					33.2. As normas emanadas pelo PCI, nas quais os padrões de segurança da LUCREE são
					baseados, sempre visando alinhamento às melhores práticas de mercado atuais, assim como a
					listagem das empresas homologadas para a realização de verificações de conformidades às
					normas, estão disponíveis no site do PCI Council (http://www.pcisecuritystandards.org).
				</p>
				<p>
					33.3. O ESTABELECIMENTO se compromete a realizar as adequações técnicas solicitadas pela
					LUCREE, tais como homologações e atualizações de sistemas, software, etc., nos prazos
					acordados, com o intuito de garantir a segurança de seu ambiente.
				</p>
				<p>
					33.4. O ESTABELECIMENTO deve comunicar imediatamente a LUCREE caso tome
					conhecimento de vazamento dos DADOS DO PORTADOR DE CARTÃO.
				</p>
			</p>


			<p><b>PRAZO DE VIGÊNCIA</b></p>

			<p style={{ textAlign: 'justify' }}>
				34. Este CONTRATO vigorará por prazo indeterminado, a contar da aceitação e inclusão do
				ESTABELECIMENTO no SISTEMA LUCREE, nos termos da Cláusula 4 deste CONTRATO.
			</p>

			<p><b>TÉRMINO/RESCISÃO DO CONTRATO</b></p>

			<p style={{ textAlign: 'justify' }}>
				35. Qualquer das Partes poderá, a qualquer tempo, sem motivação alguma, mediante
				comunicação, com até 15 (quinze) dias de antecedência, rescindir o CONTRATO ou quaisquer Aditivos
				ou PRODUTOS. Tal rescisão ocorrerá livre de direitos indenizatórios, ônus, encargos ou penalidades,
				ressalvadas as obrigações contratuais pendentes.
			</p>

			<p style={{ textAlign: 'justify' }}>
				36. Este CONTRATO poderá ser imediatamente rescindido, por justa causa, por qualquer das Partes,
				nos seguintes casos: (i) infração pela parte faltosa de qualquer das Cláusulas, termos ou condições
				deste CONTRATO; (ii) decretação de falência, deferimento de pedido de recuperação judicial ou
				proposição de recuperação extrajudicial ou declaração de insolvência de qualquer das Partes; (iii) não
				aceitação pelo ESTABELECIMENTO, de eventuais alterações efetuadas pela LUCREE no presente
				CONTRATO, em virtude de determinação das ADQUIRENTES, BANDEIRAS, do mercado de meios de
				pagamento ou da legislação. Caso qualquer das Partes incorra em qualquer das hipóteses acima, a
				Parte que rescindir este CONTRATO deverá comunicar a outra Parte, a fim de que essa tome ciência
				inequívoca da rescisão, o que produzirá seus efeitos a partir da referida comunicação.
			</p>

			<p style={{ textAlign: 'justify' }}>
				37. Constituirá igualmente justa causa de rescisão imediata, a exclusivo critério da LUCREE, sem
				prejuízo do ressarcimento das perdas e danos eventualmente acarretados, o não cumprimento pelo
				ESTABELECIMENTO das obrigações estipuladas no CONTRATO, especialmente se o
				ESTABELECIMENTO praticar ou sofrer medidas, tais como, mas não limitadas às que seguem:
			</p>

			<p style={{ textAlign: 'justify' }}>
				(a) realizar TRANSAÇÕES irregulares e em desacordo parcial ou total com os termos e condições
				deste CONTRATO, ou ainda TRANSAÇÕES suspeitas ou irregulares conforme definição das
				ADQUIRENTES, das BANDEIRAS ou regras de monitoramento de fraude da LUCREE;
			</p>

			<p style={{ textAlign: 'justify' }}>
				(b) exercer atividades ilegais e/ou indesejáveis;
			</p>

			<p style={{ textAlign: 'justify' }}>
				(c) realizar TRANSAÇÕES e/ou adotar conduta fraudulenta ou com suspeita de fraude;
			</p>

			<p style={{ textAlign: 'justify' }}>
				(d) adotar ou permitir práticas que resultem, parcial ou totalmente, em preferência por qualquer
				outro instrumento de pagamento, exclusão, condicionamento ou limitação da utilização dos
				CARTÕES e MEIOS DE PAGAMENTO;
			</p>

			<p style={{ textAlign: 'justify' }}>
				(e) ceder, transferir, emprestar, dar em caução ou garantia, entregar a terceiros, sem autorização da
				LUCREE, os EQUIPAMENTOS, aparelhos, software e MATERIAIS de propriedade da LUCREE, bem
				como quaisquer direitos e obrigações decorrentes deste CONTRATO;
			</p>

			<p style={{ textAlign: 'justify' }}>
				(f) sofrer restrição, ser impedido de abrir, manter ou ter encerrado o DOMICÍLIO BANCÁRIO em qualquer instituição bancária;
			</p>

			<p style={{ textAlign: 'justify' }}>
				(g) tornar-se inativo ou manter-se inativo, considerando-se inativo o ESTABELECIMENTO que não realizar qualquer TRANSAÇÃO dentro de determinado período, a exclusivo critério da LUCREE;
			</p>

			<p style={{ textAlign: 'justify' }}>
				(h) possuir índice de TRANSAÇÕES canceladas ou não reconhecidas bem como atingir índices de
				CONTESTAÇÃO DE TRANSAÇÕES em volume considerado elevado, segundo critérios da LUCREE
				e/ou das BANDEIRAS, após o decurso de prazo estipulado pela LUCREE para esclarecimentos e
				soluções, quando necessário e pertinente;
			</p>

			<p style={{ textAlign: 'justify' }}>
				(i) intermediar TRANSAÇÕES de terceiros, sem a devida informação à LUCREE e assinatura de
				documento específico.
			</p>

			<p style={{ textAlign: 'justify' }}>
				38. O término ou rescisão do CONTRATO não exonera as Partes do cumprimento pleno e irrestrito
				de todas as obrigações decorrentes deste CONTRATO, tais como, mas não limitadas às seguintes:
			</p>

			<p style={{ textAlign: 'justify' }}>
				(a)  a LUCREE pagar, no DOMICÍLIO BANCÁRIO do ESTABELECIMENTO ou por qualquer outro meio de
				pagamento acordado entre as Partes, os valores das TRANSAÇÕES legítimas e regulares devidas ao
				ESTABELECIMENTO; e
			</p>

			<p style={{ textAlign: 'justify' }}>
				(b) o ESTABELECIMENTO pagar à LUCREE os valores eventualmente devidos na forma deste
				CONTRATO e permitir a imediata retirada e/ou entregar os EQUIPAMENTOS, software e todos os
				MATERIAIS pertencentes à LUCREE, que estejam sob sua guarda.
			</p>
			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					38.1. A LUCREE poderá reter o pagamento mencionado no item “a” da Cláusula 38 acima, até o
					cumprimento integral, pelo ESTABELECIMENTO, de todas as obrigações previstas neste
					CONTRATO.
				</p>

				<p>
					38.2. Obriga-se o ESTABELECIMENTO, em qualquer hipótese de término ou rescisão deste
					CONTRATO, a não mais utilizar, sob qualquer pretexto ou justificativa, as marcas e/ou logotipos
					da LUCREE, bem como os EQUIPAMENTOS, aparelhos, software e MATERIAIS cedidos pela
					LUCREE.
				</p>

				<p>
					38.3. O ESTABELECIMENTO poderá cancelar qualquer um de seus PVs, sem que tal fato seja
					considerado término ou rescisão do CONTRATO caso continue com outro(s) PV(s).
				</p>

				<p>
					38.4. O cancelamento de qualquer um dos PRODUTOS contratados não implicará o término ou
					rescisão do CONTRATO, permanecendo em pleno vigor, exceto se as Partes acordarem de
					maneira diversa.
				</p>
			</p>

			<p><b>ALTERAÇÕES DO CONTRATO</b></p>

			<p style={{ textAlign: 'justify' }}>
				39.  A LUCREE, por qualquer documento, físico ou eletrônico, enviado ao ESTABELECIMENTO, por
				qualquer meio de transmissão ou comunicação ou ainda por disponibilização no PORTAL DE
				SERVIÇOS LUCREE, poderá alterar ou aditar Cláusulas ou condições deste CONTRATO ou
				incluir/alterar novos Aditivos.
			</p>

			<p style={{ paddingLeft: '30px', textAlign: 'justify' }}>
				<p>
					39.1. Se o ESTABELECIMENTO não concordar com as alterações publicizadas na forma acima,
					poderá rescindir este CONTRATO, no prazo de 10 (dez) dias, contados a partir da data do
					recebimento de comunicação específica. Caso o ESTABELECIMENTO não se manifeste em tal
					prazo, comprovadamente, em contrário a tais alterações, tal fato implicará na sua aceitação plena
					e irrestrita, sem prejuízo da possibilidade de rescindir o CONTRATO, a qualquer tempo, nos
					termos da Cláusula 35 acima.
				</p>

				<p>
					39.2. Os ESTABELECIMENTOS já credenciados ao SISTEMA LUCREE por meios de contratos
					anteriores, assinados ou não, e que não se manifestem nos termos da Cláusula 39.1 acima, terão
					sua adesão ao presente CONTRATO a partir da realização da primeira TRANSAÇÃO após a entrada
					em vigor do presente CONTRATO.
				</p>

				<p>
					39.3. Durante a vigência deste CONTRATO, o ESTABELECIMENTO poderá receber mensagens
					eletrônicas da LUCREE, de modo a assegurar a execução contratual e pós-contratual referentes
					ao presente CONTRATO, tais como avisos relacionados a alterações contratuais, atualização de
					tecnologias, situação do SISTEMA LUCREE, entre outros. Essas mensagens não serão consideradas
					indesejadas, abusivas, spam, nem e-mail marketing, tendo em vista que sua finalidade é manter
					o ESTABELECIMENTO informado a respeito de sua relação contratual com a LUCREE.
				</p>

				<p>
					39.4. As Partes poderão negociar condições comerciais especiais, dentre as quais se incluem,
					mas sem se limitar, condições comerciais de fidelização do ESTABELECIMENTO, que serão
					formalizadas por contato telefônico, documento físico ou eletrônico.
				</p>
			</p>

			<p><b>CASO FORTUITO OU DE FORÇA MAIOR</b></p>

			<p style={{ textAlign: 'justify' }}>
				40. As Partes não serão responsáveis por quaisquer falhas, interrupções ou atrasos no cumprimento
				de suas obrigações, quando decorrentes de caso fortuito ou de força maior, sendo estes excludentes
				de responsabilidade nos termos do artigo 393 do Código Civil Brasileiro, incluindo, entre outros, atos
				governamentais, limitações impostas por parte do Poder Público, interrupção na prestação de
				serviços sob licença, autorização, permissão ou concessão governamental (fornecimento de energia
				elétrica e serviços de telefonia, atuação de operadoras de serviço de telecomunicações
				interconectadas à rede do ESTABELECIMENTO e da LUCREE, entre outros), catástrofes, greves,
				perturbações da ordem pública e demais eventos da mesma natureza.
			</p>

			<p><b>DISPOSIÇÕES GERAIS</b></p>

			<p style={{ textAlign: 'justify' }}>
				41. O ESTABELECIMENTO, com relação aos nomes e às marcas da LUCREE e/ou das BANDEIRAS,
				obriga-se a utilizá-las nos estritos termos deste CONTRATO, nas formas, cores e modelos
				indicados e aprovados previamente pela LUCREE, não podendo alterá-las, registrá- las ou usálas de forma indevida ou infringindo os direitos de propriedade da LUCREE ou das BANDEIRAS.
			</p>

			<p style={{ textAlign: 'justify' }}>
				42. A eventual tolerância ou transigência das Partes em exigir o integral cumprimento das
				obrigações contratuais não constituirá novação, renúncia ou modificação do acordado,
				tratando-se de mera liberalidade, podendo a respectiva Parte exigir, a qualquer tempo, o
				cumprimento integral de todas as obrigações previstas neste CONTRATO.
			</p>

			<p style={{ textAlign: 'justify' }}>
				43. O ESTABELECIMENTO autoriza a LUCREE a incluir, sem qualquer ônus ou encargos, seu nome,
				marcas e logotipos, endereço, bem como os dos respectivos PVs ou filiais ou dependências que
				designar como ESTABELECIMENTO em ações de marketing, comunicados, catálogos e/ou
				quaisquer outros materiais promocionais do SISTEMA LUCREE, ressalvado o direito do
				ESTABELECIMENTO de revogar, a qualquer momento, por escrito, essa autorização.
			</p>

			<p style={{ textAlign: 'justify' }}>
				44. Este CONTRATO obriga as Partes, bem como seus respectivos sucessores a qualquer título.
			</p>

			<p style={{ textAlign: 'justify' }}>
				45. O ESTABELECIMENTO deverá prontamente comunicar à LUCREE quaisquer alterações relativas
				às informações prestadas à LUCREE, especialmente as referentes à composição societária,
				denominação social, objeto social, endereços comerciais e eletrônicos, endereços de
				correspondência ou números de telefone.
			</p>

			<p style={{ textAlign: 'justify' }}>
				46. A nulidade ou invalidade de qualquer das disposições deste CONTRATO não implicará na
				nulidade ou invalidade das demais, que permanecerão válidas, produzindo plenos efeitos de
				direito.
			</p>

			<p style={{ textAlign: 'justify' }}>
				47. Ocorrendo fatos não previstos pela LUCREE que possam prejudicar o equilíbrio econômico financeiro, afetando a adequada manutenção da operacionalidade do SISTEMA LUCREE, as taxas
				e as tarifas referidas neste CONTRATO poderão sofrer alterações, a serem prévia e
				expressamente comunicadas ao ESTABELECIMENTO, de forma a restaurar o equilíbrio contratual
				entre as Partes e a eficiência do SISTEMA LUCREE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				48. O ESTABELECIMENTO concorda que as gravações magnéticas, digitalizadas ou telefônicas, de
				negociações envolvendo qualquer PRODUTO, qualquer negociação específica ou qualquer
				termo, Cláusula ou condição deste CONTRATO, poderão ser utilizadas como prova, inclusive em
				Juízo, por qualquer das Partes.
			</p>

			<p style={{ textAlign: 'justify' }}>
				49. Este CONTRATO não estabelece vínculo trabalhista, previdenciário ou societário entre a LUCREE
				e o ESTABELECIMENTO.
			</p>

			<p style={{ textAlign: 'justify' }}>
				50. A LUCREE poderá ceder, transferir, total ou parcialmente, os seus direitos e obrigações
				decorrentes deste CONTRATO para suas coligadas, controladas, controladores e terceiros,
				independente de prévia notificação ao ESTABELECIMENTO. É vedado ao ESTABELECIMENTO, a
				que título for, a cessão deste Contrato e dos direitos dele decorrentes, salvo se por anuência
				expressa e formal da LUCREE.
			</p>

			<p><b>FORO</b></p>

			<p style={{ textAlign: 'justify' }}>
				51. Fica eleito o Foro do domicílio do ESTABELECIMENTO como o foro competente para dirimir
				eventuais questões ou litígios entre as Partes.
			</p>

			<p style={{ textAlign: 'justify' }}>
				O presente CONTRATO, ao qual o ESTABELECIMENTO automaticamente adere no momento de seu
				credenciamento ao SISTEMA LUCREE, encontra-se disponível no PORTAL DE SERVIÇOS LUCREE.
			</p>

			<p><b>ANEXO I –DEFINIÇÕES</b></p>

			<p style={{ textAlign: 'justify' }}>
				Para o perfeito entendimento e interpretação deste CONTRATO são adotadas as seguintes definições, grafadas em caixa alta, utilizadas no singular ou no plural:
			</p>

			<p style={{ textAlign: 'justify' }}>
				ADQUIRENTES – Empresas responsáveis pela comunicação entre as BANDEIRAS, EMISSORES e os respectivos titulares de CARTÕES.
			</p>

			<p style={{ textAlign: 'justify' }}>
				BANDEIRAS – Empresas nacionais ou estrangeiras, detentoras dos direitos de propriedade e franqueadoras de suas marcas e logotipos, para uso da LUCREE, das ADQUIRENTES e dos EMISSORES, mediante a especificação de regras gerais de organização e funcionamento do sistema de CARTÕES e MEIOS DE PAGAMENTO e/ou PRODUTOS.
			</p>

			<p style={{ textAlign: 'justify' }}>
				CANCELAMENTO DA TRANSAÇÃO – Processo em que o ESTABELECIMENTO solicita à LUCREE o cancelamento de uma TRANSAÇÃO já processada.
			</p>

			<p style={{ textAlign: 'justify' }}>
				CARTÕES – Instrumentos de identificação e de pagamento, configurados ou apresentados sob a forma de cartões plásticos capazes de realizar várias funções, disponibilizadas pelos EMISSORES, para uso pessoal e intransferível dos PORTADORES, aceitos no SISTEMA LUCREE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				CENTRAL DE ATENDIMENTO – Canais disponibilizados pela LUCREE aos ESTABELECIMENTOS para atendimento de dúvidas, pesquisas operacionais e contratação de PRODUTOS e EQUIPAMENTOS.
			</p>

			<p style={{ textAlign: 'justify' }}>
				CHIP (ou SIMCARD) – Microprocessador introduzido nos CARTÕES ou MEIOS DE PAGAMENTO, que possui programação e memória de dados do PORTADOR, cuja leitura é feita nos EQUIPAMENTOS, com uso de SENHA e/ou assinatura do PORTADOR.
			</p>

			<p style={{ textAlign: 'justify' }}>
				CÓDIGO DE AUTORIZAÇÃO – Conjunto de caracteres gerado e fornecido a exclusivo critério dos
				EMISSORES e informado ao ESTABELECIMENTO pela LUCREE, cuja finalidade exclusiva é, no momento
				da TRANSAÇÃO, identificar que: (i) o CARTÃO e/ou MEIO DE PAGAMENTO consultado, não se
				encontra bloqueado ou cancelado; e (ii) o valor e a modalidade da TRANSAÇÃO são aprovados pelo
				EMISSOR ou pela BANDEIRA.
			</p>

			<p style={{ textAlign: 'justify' }}>
				COMPROVANTES DE VENDAS – Documentos padronizados pela LUCREE que poderão ser emitidos
				pelos EQUIPAMENTOS ou preenchidos manualmente pelos ESTABELECIMENTOS no momento da
				realização da TRANSAÇÃO.
			</p>

			<p style={{ textAlign: 'justify' }}>
				CONTRATO – É este Contrato de Credenciamento e Adesão de Estabelecimentos ao Sistema LUCREE
				devidamente registrado e disponibilizado no PORTAL DE SERVIÇOS LUCREE para ciência e consulta
				pelos ESTABELECIMENTOS, e seus respectivos Aditivos, bem como qualquer documento relacionado.
			</p>

			<p style={{ textAlign: 'justify' }}>
				CONTESTAÇÃO DA TRANSAÇÃO (“CHARGEBACK”) – Processo de devolução de uma TRANSAÇÃO, por
				contestação do PORTADOR ou do EMISSOR, de acordo com as regras e prazos definidos pelas
				BANDEIRAS, conforme detalhado no PORTAL DE SERVIÇOS LUCREE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				DADOS DO PORTADOR DE CARTÃO – Informações dos PORTADORES necessárias para a realização de
				uma TRANSAÇÃO, tais como: número do CARTÃO, nome do PORTADOR como escrito no CARTÃO,
				data de vencimento do CARTÃO, bem como todas as informações presentes na tarja magnética do
				CARTÃO, toda e qualquer SENHA relacionada ao seu uso e os códigos de segurança e de serviço.
			</p>

			<p style={{ textAlign: 'justify' }}>
				DOMICÍLIO BANCÁRIO – Conta de livre movimentação de titularidade do ESTABELECIMENTO mantida
				junto à instituição bancária participante do SISTEMA LUCREE, onde receberá os créditos e os débitos
				decorrentes da realização das TRANSAÇÕES previstas neste CONTRATO. O ESTABELECIMENTO, desde
				que previamente autorizado pela LUCREE, poderá optar por DOMICÍLIO BANCÁRIO em instituição
				bancária não participante do SISTEMA LUCREE, sujeitando-se nesse caso aos custos incorridos pela
				LUCREE nas operações de pagamento das TRANSAÇÕES efetuadas mediante DOC, TED ou qualquer
				outro meio similar.
			</p>

			<p style={{ textAlign: 'justify' }}>
				EMISSORES – Empresas nacionais ou estrangeiras, instituições bancárias ou não, autorizadas pelas
				BANDEIRAS a emitir e conceder CARTÕES e/ou disponibilizar PRODUTOS, para uso no Brasil e/ou no
				exterior.
			</p>

			<p style={{ textAlign: 'justify' }}>
				EQUIPAMENTOS – Quaisquer aparelhos, independente da tecnologia (mecânicos, elétricos,
				eletrônicos, magnéticos, eletromagnéticos, radiotransmissores, telefônicos ou utilizando quaisquer
				outros meios disponíveis), bem como os softwares relacionados, de propriedade da LUCREE, do
				ESTABELECIMENTO ou de terceiros (incluindo, mas não se limitando, a PIN PAD e TERMINAL
				POS/POO), fornecidos e/ou instalados no ESTABELECIMENTO, a título gratuito ou oneroso, para a
				realização de TRANSAÇÕES e a execução de outras funções atribuídas ao SISTEMA LUCREE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				ESTABELECIMENTO – Pessoa jurídica ou pessoa física, fornecedora de bens e/ou prestadora de
				serviços, constituída(s) e localizada(s) dentro do território brasileiro, credenciada ao SISTEMA
				LUCREE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				MATERIAL – Todo e qualquer suprimento fornecido pela LUCREE ao ESTABELECIMENTO, a título
				oneroso ou gratuito, tais como: bobinas, COMPROVANTES DE VENDA, formulários, adesivos, display,
				material promocional ou operacional.
			</p>

			<p style={{ textAlign: 'justify' }}>
				MEIOS DE PAGAMENTO – Instrumentos físicos ou eletrônicos com funções de pagamento (múltiplas
				ou não), aceitos ou que venham a ser aceitos no SISTEMA LUCREE, disponibilizadas pelos EMISSORES,
				para uso pessoal e intransferível dos PORTADORES.
			</p>

			<p style={{ textAlign: 'justify' }}>
				NÚMERO DE PV – Número dado ao ESTABELECIMENTO ou a cada unidade comercial (PONTO DE
				VENDA - PV) de uma rede de ESTABELECIMENTOS credenciados ao SISTEMA LUCREE. Cada PV poderá
				pagar TAXA DE DESCONTO e/ou TARIFA POR TRANSAÇÃO diferente dos demais.
			</p>

			<p style={{ textAlign: 'justify' }}>
				PROPOSTA DE CREDENCIAMENTO – É a Proposta de Credenciamento onde constam os dados
				mínimos básicos para credenciamento do ESTABELECIMENTO, cujo modelo variará conforme o canal
				de credenciamento.
			</p>

			<p style={{ textAlign: 'justify' }}>
				PDV/TEF – Conjunto de equipamentos e softwares de processamento de dados de propriedade do
				ESTABELECIMENTO ou de terceiros, integrantes do seu sistema de automação comercial, e que
				conectados à REDE DE CAPTURA, mediante prévia autorização da LUCREE, além de funções de
				gerenciamento interno de informações, podem realizar TRANSAÇÕES, emitir COMPROVANTES DE
				VENDAS e RESUMOS DE VENDAS, efetuar intercâmbio de informações e executar outras funções
				atribuídas pelo SISTEMA LUCREE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				PERIFÉRICOS: Artefatos acessórios dos EQUIPAMENTOS, que permitem o seu funcionamento, tais
				como, exemplificativamente, CHIP ou SIMCARD, fontes de alimentação de energia elétrica e cabos
				telefônicos.
			</p>

			<p style={{ textAlign: 'justify' }}>
				PIN PAD – Equipamento acoplado a um PDV/TEF, de propriedade do ESTABELECIMENTO, da LUCREE
				ou de terceiros, para a leitura da tarja magnética, do CHIP e/ou para a digitação de SENHA.
				PORTADORES – Pessoas físicas ou prepostos de pessoas jurídicas, detentoras de CARTÃO e/ou
				usuárias de PRODUTOS e autorizados a realizar TRANSAÇÕES.
			</p>

			<p style={{ textAlign: 'justify' }}>
				PORTAL DE SERVIÇOS LUCREE – Página na Internet que oferece informações, vantagens e serviços
				on-line aos ESTABELECIMENTOS credenciados ou que venham a se credenciar ao SISTEMA LUCREE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				PRODUTOS – Todo e qualquer produto ou serviço disponibilizado através do SISTEMA LUCREE, cujas
				características, especificações e condições de utilização e aceitação, determinadas pela LUCREE e
				aceitas pelo ESTABELECIMENTO, encontram-se reguladas em documentos específicos disponíveis no
				PORTAL DE SERVIÇOS LUCREE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				RECEBIMENTO ANTECIPADO DE VENDAS (“RAV”) – Valor que o ESTABELECIMENTO pode receber e que
				consiste no pagamento das TRANSAÇÕES realizadas pelo ESTABELECIMENTO em prazo inferior ao
				estipulado na PROPOSTA DE CREDENCIAMENTO, sempre a exclusivo critério da LUCREE, mediante
				desconto adicional deduzido do VALOR LÍQUIDO.
			</p>

			<p style={{ textAlign: 'justify' }}>
				REDE DE CAPTURA – Conjunto formado pelos sistemas de comunicação e transmissão de dados,
				computadores (hardware e software) e outros recursos tecnológicos de propriedade da LUCREE ou
				de terceiros por ela contratados, com a finalidade de manter em funcionamento o SISTEMA LUCREE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				RESUMOS DE VENDAS – Documentos padronizados, fornecidos pela LUCREE, gerados
				eletronicamente pelo SISTEMA LUCREE, para registrar a quantidade e o valor total das TRANSAÇÕES
				realizadas em determinado dia.
			</p>

			<p style={{ textAlign: 'justify' }}>
				SENHA – Número de identificação pessoal do PORTADOR que permite ao EMISSOR autenticar o
				PORTADOR do CARTÃO ou MEIO DE PAGAMENTO.
			</p>

			<p style={{ textAlign: 'justify' }}>
				SISTEMA LUCREE – Conjunto de pessoas físicas ou jurídicas (a LUCREE, ADQUIRENTES, EMISSORES,
				BANDEIRAS, parceiros, instituições financeiras, prestadores de serviços, fornecedores, entre outros),
				que, de acordo com as normas, procedimentos e contratos que regulam a atividade, e com a
				utilização da tecnologia operacional e equipamentos adequados, efetiva as operações de captura,
				roteamento, transmissão, processamento e liquidação financeira das TRANSAÇÕES. Essas atividades
				realizadas pelo SISTEMA LUCREE constituem um conjunto de serviços interligados e interconectados
				e que viabilizam a administração de pagamentos mediante o uso de CARTÕES.
			</p>

			<p style={{ textAlign: 'justify' }}>
				SUBADQUIRENTE – Empresa responsável pela intermediação entre o ESTABELECIMENTO,
				PORTADORES e as ADQUIRENTES, mediante a realização de pagamentos e recebimentos efetuados
				por meio eletrônico. A LUCREE atua como SUBADQUIRENTE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				TARIFA POR TRANSAÇÃO – Remuneração por TRANSAÇÃO, em moeda corrente e com valor fixo
				estipulado entre as Partes, paga pelo ESTABELECIMENTO à LUCREE, sendo composta de valores
				devidos à LUCREE, ao EMISSOR e à BANDEIRA, que possuem denominações e condições acertadas
				em contratos próprios.
			</p>

			<p style={{ textAlign: 'justify' }}>
				TAXA DE ADESÃO – Remuneração, em moeda corrente, paga pelo ESTABELECIMENTO, após seu
				credenciamento ou recredenciamento ao SISTEMA LUCREE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				TAXA DE CONECTIVIDADE - Taxa mensal cobrada pela conectividade de ESTABELECIMENTOS que
				utilizem PDV/TEF ou outro PRODUTO para o qual tal taxa seja aplicável.
			</p>

			<p style={{ textAlign: 'justify' }}>
				TAXA DE DESCONTO – Remuneração por TRANSAÇÃO que consiste em um percentual incidente sobre
				o VALOR BRUTO das TRANSAÇÕES, cujo fator é estipulado entre as Partes. Trata-se de remuneração
				paga pelo ESTABELECIMENTO à LUCREE, sendo composta de valores devidos à LUCREE, ao
				ADQUIRENTE, ao EMISSOR e à BANDEIRA, que possuem denominações e condições acertadas em
				contratos próprios.
			</p>

			<p style={{ textAlign: 'justify' }}>
				TERMINAIS POS/POO – Terminais eletrônicos, com ou sem fio, fornecidos pela LUCREE ao
				ESTABELECIMENTO mediante o pagamento de aluguel, ou venda, para a realização de TRANSAÇÕES
				eletrônicas, emissão de COMPROVANTES DE VENDAS e RESUMOS DE VENDAS eletrônicos e execução
				de outras funções atribuídas pelo SISTEMA LUCREE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				TRANSAÇÕES – Todas e quaisquer aquisições de bens e/ou serviços, oferta de PRODUTOS aos
				ESTABELECIMENTOS, EMISSORES, parceiros e fornecedores, transferência de fundos, saques de
				dinheiro ou outras modalidades de operações permitidas no SISTEMA LUCREE, realizadas pelo
				PORTADOR em ESTABELECIMENTOS no Brasil, mediante a utilização de CARTÕES e/ou MEIOS DE
				PAGAMENTO e efetivadas sob a forma eletrônica.
			</p>

			<p style={{ textAlign: 'justify' }}>
				TRANSAÇÕES OFF-LINE – Modalidade de captura eletrônica de TRANSAÇÕES, não efetuadas em
				tempo real com a LUCREE.

			</p>

			<p style={{ textAlign: 'justify' }}>
				TRANSAÇÕES ON-LINE – Modalidade de captura e autorização eletrônica de TRANSAÇÕES, mediante
				comunicação em tempo real com a LUCREE.
			</p>

			<p style={{ textAlign: 'justify' }}>
				TRANSMISSÃO DE ARQUIVOS – Captura de TRANSAÇÃO OFF-LINE para posterior envio pelo
				ESTABELECIMENTO à LUCREE, e vice-versa, de arquivos de informações, por meio de transmissão
				eletrônica.
			</p>

			<p style={{ textAlign: 'justify' }}>
				VALOR BRUTO – Valor total das TRANSAÇÕES realizadas pelo ESTABELECIMENTO antes da dedução
				da TAXA DE DESCONTO e/ou TARIFA POR TRANSAÇÃO e da cobrança de quaisquer outras taxas,
				tarifas e/ou deduções, estas conforme quaisquer das alternativas definidas na Cláusula 8.
			</p>

			<p style={{ textAlign: 'justify' }}>
				VALOR LÍQUIDO - Valor a ser creditado ao ESTABELECIMENTO correspondente ao VALOR BRUTO, já
				deduzido da TAXA DE DESCONTO e/ou da TARIFA POR TRANSAÇÃO e da cobrança de quaisquer
				outras taxas, tarifas e/ou deduções, estas conforme quaisquer das alternativas definidas na Cláusula 8.
			</p>

		</DivScrollBody>
	);
}

